import {getInitialData} from '@/api/system'
import Cookies from 'js-cookie'
import store from 'store'
import {removeCredentials} from '@/utils/request'

const global_message_user = [437568,181967,284240,2111250,632133,288866,1640284,119605,161237,285289,878185,577296,398329,37746,2054029,541838,1465991,2104581,221659,84911,346371,911916,584726,844792,136624,349036,556666,66191,720829,1435427,707163,846245,830302,845009,720413,1236899,1517186,133500,862475,151874,709578,1799180,354098,346437,2318013,103929,1482566,159933,1410723,2318140,331469,667359,232183,160323,558895,694413,787538,418100,1225960,225859,66204,1439145,1435446,1435455,2177612,859485,581665,3754,277917,1557447,699,407523,1301729,284206,1393728,1564107,2319433,303819,277406,322905,172725,298841,528242,346136,1401342,1517263,1487147,186703,2017237,197667,278337,1319507,862782,1598029,298547,1297185,284262,1439139,1427,344195,410127,1593324,295376,577879,661033,176659,417195,733677,1553353,2317774,285978,278965,867214,165099,590224,1566949,286247,136625,254707,1652023,397348,346891,849304,1307612,175065,85472,1590299,197225,2285517,425374,590122,849590,1457577,91714,2086153,160084,284681,1534054,278266,1540266,550437,639161,1593219,762331,424542,583378,347970,739180,326840,559085,1440099,285745,322776,729330,2272374,2115151,1417554,739973,262029,550356,1602195,526267,568857,132002,154240,280174,183522,897731,279474,1599086,1428978,161257,222934,368504,687,1564283,197381,162991,566604,497911,346335,1830053,1221527,777683]

const app = {
  state: {
    // 是否调试模式
    debug: false,
    initialized: false,
    is_prerelease: Cookies.get('prerelease') == 1,
    logo: 'https://img.aakit.cn/classkit/static/images/logo.jpg',
    assistant_logo: 'https://img.aakit.cn/classkit/static/images/assistant_logo.png',
    // 页面是否被蒙层盖住
    overlayed: false,
    // 或者text，会出现在loading图下方
    is_loading: false,
    is_initial_loading: false,
    loading_toast_text: '',
    is_miniprogram: false,
    mp_app_id: '',
    mp_version: 0,
    is_wechat: navigator.userAgent.indexOf('MicroMessenger') >= 0,
    is_android_wechat: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('Android') >= 0 && navigator.userAgent.indexOf('WeChat') >= 0 && navigator.userAgent.indexOf('Weixin') >= 0,
    is_android_wework: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('Android') >= 0 && navigator.userAgent.indexOf('wxwork') >= 0,
    is_iphone_wechat: navigator.userAgent.indexOf('MicroMessenger') >= 0 && (navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPad') >= 0) && navigator.userAgent.indexOf('wxwork') < 0,
    is_iphone_wework: navigator.userAgent.indexOf('MicroMessenger') >= 0 && (navigator.userAgent.indexOf('iPhone') >= 0 || navigator.userAgent.indexOf('iPad') >= 0) && navigator.userAgent.indexOf('wxwork') >= 0,
    is_windows_wechat: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('WindowsWechat') >= 0 && navigator.userAgent.indexOf('wxwork') < 0,
    is_windows_wework: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('WindowsWechat') >= 0 && navigator.userAgent.indexOf('wxwork') >= 0,
    is_mac_wechat: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('Macintosh') >= 0 && navigator.userAgent.indexOf('MacWechat') >= 0,
    is_mac_wework: navigator.userAgent.indexOf('MicroMessenger') >= 0 && navigator.userAgent.indexOf('Macintosh') >= 0 && navigator.userAgent.indexOf('wxwork') >= 0,
    // 年级选项
    grade_options: [],
    // 班级选项
    class_options: {},
    // 学号选项
    sn_options: {},
    // 管理员角色选项
    class_admin_options: [],
    // 班级所有角色选项
    class_role_options: [],
    // 任教科目老师选项
    teacher_options: [],
    // 亲人角色选项
    relative_role_options: [],
    // 科目选项
    subject_options: [],
    // 分享logo
    social_icons: {
      'notification': 'https://img.aakit.cn/classkit/static/images/social/notification.png',
      'homework': 'https://img.aakit.cn/classkit/static/images/social/homework.png',
      '语文': 'https://img.aakit.cn/classkit/static/images/social/chinese.png',
      '数学': 'https://img.aakit.cn/classkit/static/images/social/math.png',
      '英语': 'https://img.aakit.cn/classkit/static/images/social/english.png',
      
      '物理': 'https://img.aakit.cn/classkit/static/images/social/physics.png',
      '化学': 'https://img.aakit.cn/classkit/static/images/social/chemistry.png',
      '历史': 'https://img.aakit.cn/classkit/static/images/social/history.png',
      '地理': 'https://img.aakit.cn/classkit/static/images/social/geography.png',
      '政治': 'https://img.aakit.cn/classkit/static/images/social/politics.png',
      '品德': 'https://img.aakit.cn/classkit/static/images/social/morality.png',
      '科学': 'https://img.aakit.cn/classkit/static/images/social/science.png',
      '生物': 'https://img.aakit.cn/classkit/static/images/social/biology.png',
      '劳动': 'https://img.aakit.cn/classkit/static/images/social/labour.png',
      '体育': 'https://img.aakit.cn/classkit/static/images/social/sports.png',

      '美术': 'https://img.aakit.cn/classkit/static/images/social/art.png',
      '音乐': 'https://img.aakit.cn/classkit/static/images/social/music.png',
      '其它': 'https://img.aakit.cn/classkit/static/images/social/other.png',
      'punch_in': 'https://img.aakit.cn/classkit/static/images/social/punch_in.png',
      'form': 'https://img.aakit.cn/classkit/static/images/social/form.png',
      'payment': 'https://img.aakit.cn/classkit/static/images/social/payment.png',
      'examination': 'https://img.aakit.cn/classkit/static/images/social/examination.png',
    },
    bot_qrcode: '',
    customer_qrcode: '',
    show_vedio: true,
    show_global_message: false,
  },
  mutations: {
    SET_INITIALIZED: state => {
      state.initialized = true
    },
    SET_DEBUG_MODE: (state, debug) => {
      state.debug = debug
    },
    UPDATE_LOADING_TOAST_TEXT: (state, text) => {
      state.loading_toast_text = text
    },
    UPDATE_INITIAL_LOADING_STATUS: (state, loading) => {
      state.is_initial_loading = loading
    },
    UPDATE_LOADING_STATUS: (state, loading) => {
      state.is_loading = loading
    },
    SET_IS_WECHAT: (state, wechat) => {
      state.is_wechat = wechat
    },
    SET_IS_WINDOWS_WECHAT: (state, wechat) => {
      state.is_windows_wechat = wechat
    },
    SET_OVERLAYED: (state, overlayed) => {
      state.overlayed = overlayed
    },
    SET_ALL_OPTIONS: (state, options) => {
      // 年级选项
      state.grade_options = options.grade_lists;
      // 班级选项
      state.class_options = options.class_lists;
      // 学号选项
      state.sn_options = options.sn_type_lists;
      // 管理员角色选项
      state.class_admin_options = options.create_class_role_lists;
      // 班级所有角色选项
      state.class_role_options = options.join_class_role_lists;
      // 任教科目老师选项
      state.teacher_options = options.teacher_call_lists;
      // 亲人角色选项
      state.relative_role_options = options.parents_call_lists;
      // 科目选项
      state.subject_options = options.subject_lists;
      // 机器人二维码
      state.bot_qrcode = options.robot_qrcode
      //客服二维码
      state.customer_qrcode = options.customer_qrcode
    },
    SET_PRERELEASE: (state, go) => {
      state.is_prerelease = go

      if (go) {
        Cookies.set('prerelease', 1)
      } else {
        Cookies.remove('prerelease')
      }
    },
    SET_SHOW_VEDIO: (state, isShow) => {
      state.show_vedio = isShow
    },
    SET_GLOBAL_MESSAGE_VISIBLE: (state, visible) => {
      state.show_global_message = visible
    },
    SET_IS_MINIPROGRAM: (state, is_miniprogram) => {
      state.is_miniprogram = is_miniprogram
    },
    SET_MP_APP_ID: (state, app_id) => {
      state.mp_app_id = app_id
    },
    SET_MINIPROGRAM_VERSION: (state, version) => {
      state.mp_version = version || 0
    },
  },
  actions: {
    commitInitialState({commit}, initial_data) {
      // 初始化环境变量
      commit('SET_INITIALIZED', true)

      // 选项
      commit("SET_ALL_OPTIONS", initial_data)

      commit("SET_USER_SETTINGS", initial_data.user_settings)

      commit("SET_FEATURE_BADGES", initial_data.feature_badges)

      // 设置用户信息
      if (initial_data.user) {
        commit('SET_USER', initial_data.user)

        /**
         * 若当前处于AB测试中，
         * 则查看用户是否有测试任务
         * 没有则退出预发布
         */
        if (this.state.app.is_prerelease) {
          if (!initial_data.user.try_version) {
            this.dispatch('exitPrerelease')
          }

        /**
         * 若当前未处于AB测试中，
         * 则查看用户是否有测试任务
         * 有则退出预发布
         */
        } else {
          if (initial_data.user.try_version) {
            this.dispatch('enterPrerelease')
          }
        }
      }
    },
    loadInitialData({commit}) {
      commit('SET_IS_WECHAT', navigator.userAgent.indexOf('MicroMessenger') >= 0)
      commit('SET_IS_WINDOWS_WECHAT', navigator.userAgent.indexOf('WindowsWechat') >= 0)
      commit('SET_DEBUG_MODE', Cookies.get('x-debug'))
      // console.log('req 0000')
      return new Promise((resolve, reject) => {
        // console.log('req 1111')
        // const cached = store.get('initial_data')
        // if (cached) {
        //   this.dispatch('commitInitialState', cached)
        // }

        getInitialData()
        .then((res) => {
          // console.log('req 2222')
          const data = res.data

          this.dispatch('commitInitialState', data)
          // console.log('req 3333')
          if (data.user) {
            store.set('initial_data', data)
          } else {
            store.remove('initial_data', data)
          }
          // console.log('req 5555')
          resolve(res.data)
        }).catch((e) => {
          // console.log('req 6666')
          reject(e)
        })

        // if (cached) {
        //   resolve(cached)
        // }
      })
    },
    clearBaseCache() {
      store.remove('initial_data')
    },
    cleanAllCache() {
      removeCredentials()
      localStorage.clear()
      sessionStorage.clear()
      store.clearAll()
      var cookies = Cookies.get()
      for (const key in cookies) {
        if (Object.hasOwnProperty.call(cookies, key)) {
          console.log('removeCookie:', key, '***', cookies[key])
          Cookies.remove(key)
        }
      }
    },
    setIsMiniprogram({commit}, is) {
      commit('SET_IS_MINIPROGRAM', is)
    },
    setMpAppId({commit}, app_id) {
      commit('SET_MP_APP_ID', app_id)
    },
    setMiniprogramVersion({commit}, version) {
      commit('SET_MINIPROGRAM_VERSION', version)
    },
    initialLoading({commit}) {
      commit('UPDATE_INITIAL_LOADING_STATUS', true)
    },
    toastLoading({commit}, text) {
      if (text) {
        commit('UPDATE_LOADING_TOAST_TEXT', text)
      } else {
        commit('UPDATE_LOADING_TOAST_TEXT', '')
      }
    },
    startLoading({commit}, text) {
      commit('UPDATE_LOADING_STATUS', true)
    },
    stopLoading({commit}) {
      commit('UPDATE_LOADING_STATUS', false)

      // 初始化加载完成
      // 记录时间长度
      if (this.state.app.is_initial_loading) {
        if(window.$baidu) {
          const time = parseInt( (Date.now() - P_START)/1000 )
          $baidu.event('前端性能','加载耗时', '初次加载', time)
        }
      }

      commit('UPDATE_INITIAL_LOADING_STATUS', false)
    },
    switchDebug({commit}, start) {
      commit('SET_DEBUG_MODE', start)
    },
    setOverlayed({commit}, overlayed) {
      commit('SET_OVERLAYED', overlayed)
    },
    reload() {
      var query = window.location.search
      var hash = window.location.hash
      var url = window.location.href
      var doubleReload = true
      if (query.indexOf('reload=1') != -1) {
        doubleReload = false
      } else {
        if (query.length > 0) {
          url = url.replace(query,'')
          query = query + '&reload=1'
        } else {
          query = '?reload=1'
        }
        if (hash.length > 0) {
          url = url.replace(hash,'')
        }
        url = url + query + hash
      }

      window.location.reload(true)
      if (doubleReload) {
        // 兼容无法reload的机型
        window.location = url
      }
      // window.location = window.location.href.replace(location.hash,'') + '#refresh'
    },
    enterPrerelease({ commit }) {
      commit('SET_PRERELEASE', true)

      this.dispatch('reload')
    },
    exitPrerelease({ commit }) {
      commit('SET_PRERELEASE', false)

      this.dispatch('reload')
    },
    togglePrerelease({commit}) {
      if (this.state.app.is_prerelease) {
        commit('SET_PRERELEASE', true)
      } else {
        commit('SET_PRERELEASE', false)
      }

      this.dispatch('reload')
    },
    toggleShowVedio({commit}, show) {
      commit('SET_SHOW_VEDIO', show)
    },
    // closeGlobalMessage({commit}) {
    //   localStorage.setItem('close_global_message_timestamp', new Date().getTime())
    //   commit('SET_GLOBAL_MESSAGE_VISIBLE', false)
    // },
    // toggleShowGlobalMessage({commit}, show) {
    //   // if (process.env.NODE_ENV == 'production') {
    //   if (!this.state.user.survey_url) {
    //     return
    //   }
    //   // }
    //   if (show) {
    //     const timeStamp = localStorage.getItem('close_global_message_timestamp')
    //     if (timeStamp && new Date().getTime() - Number(timeStamp) < 86400000 * 3) {
    //       return
    //     }
    //   }

    //   commit('SET_GLOBAL_MESSAGE_VISIBLE', show)
    // }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js